import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { MustMatch } from 'src/app/confirmed.validator';
import { ProfileService } from './service/profile.service';
import { Store } from 'src/app/core/store/store';
import { User } from 'src/app/shared/models/user.model';
import { countryData } from 'src/app/shared/utils/country-code';
import { timezoneData } from 'src/app/shared/utils/timezone';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { Router } from '@angular/router';
import { EventsService } from 'src/app/shared/services/events.service';
import { PasswordValidator } from 'src/app/shared/validator/password.validator';
import { AuthService } from '../../auth/services/auth.service';
import { EncryptionService } from '../../auth/services/encryption.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  profileForm: FormGroup;
  resetPasswordForm: FormGroup;
  submitted = false;
  user: User;
  lastLoginDate: string;
  imgFile: string;

  isChangeRequired = true;
  profilePic
  isProfilePic = false;
  isProfileDisable = true;
  reset_password_enabled = false;
  country = countryData;
  timezoneDrop = timezoneData;
  countryObj = this.country.find(x => x.code == 'IN');
  timezoneObj = this.timezoneDrop.find(x => x.value == '+5:30')
  defaultCountryCode = `${this.countryObj.dial_code} (${this.countryObj.code})`;
  defaultTimezone = `${this.timezoneObj.label}`;
  showDropDown = false;
  showTimeZone = false;
  activationData;
  userPrevObj =  { firstName: '', lastName: '', phone: '', timeZone: '' };
  isProfileUpdated = false;
  storeData:any;
  isleaderboard:any;
  imageUploadEvent: any;
  imageUpload: boolean= false;

  constructor(private fromBuilder: FormBuilder, private profileService: ProfileService,
    private toaster: ToastrService, private store: Store, private authService: AuthService,
    private encryptionService: EncryptionService,
    private dashboardService: DashboardService,private router: Router, private eventsService: EventsService) {
    this.profileForm = this.fromBuilder.group({
      "firstName": ['', [Validators.required, Validators.pattern(/^[a-zA-Z '.-]+$/)]],
      "email": [{value:'',disabled: true}],
      "lastName": ["", [Validators.pattern(/^[a-zA-Z '.-]+$/)]],
      "phone": [""],
      "imgSrc": [""],
      "countryCode": [null],
      "receiveUpdatesOnWhatsapp": [false],
      "timeZone" : [null]
    }),

      this.resetPasswordForm = this.fromBuilder.group({
        "newPassword": ['', [Validators.required, Validators.minLength(8),Validators.maxLength(16),PasswordValidator.strong]],
        "confirmPassword": ['', Validators.required],
        "oldPassword": ['', Validators.required]
      },
        {
          validator: MustMatch('newPassword', 'confirmPassword')
        });

  }

  ngOnInit(): void {
    let element = document.getElementById("ipjSidebar");
    if(!element?.classList?.contains('hide-on-mobile')) {
        element?.classList.add("hide-on-mobile");
    }
    let sideBarOverlay = document?.getElementById('siderbar__overlay');
    console.log(sideBarOverlay);
    
    if(sideBarOverlay?.classList.length == 0 && !sideBarOverlay.classList.contains('d-none')){
      sideBarOverlay.className = 'd-none';
    }
    this.getProfileById("user id put here");
    this.store.select<User>('user').subscribe(user => {
      if (user) {
        this.user = user;
        this.lastLoginDate = user.lastLoginDate;
        this.profilePic = user.profilePic;
        this.profileForm.get('receiveUpdatesOnWhatsapp').patchValue(this.user.receiveUpdatesOnWhatsapp)
        // this.currentCourse = user.visitedCourses.find(c => c.id == this.courseId);

        // capture profile update event
        try {
          if(this.user && this.activationData && this.userPrevObj && this.isProfileUpdated) {
            let eventData = { user: this.user, activationData: this.activationData, userPrevData: this.userPrevObj }
            this.eventsService.saveUserProfileEvent(eventData);
            this.isProfileUpdated = false;
          }
        } catch (err) { console.log(err); }
      }
    });
    // if (this.profilePic != null) {
    //   this.isProfilePic = true;
    // }
    // this.mustMatchPassword();
    this.filterInit();
    this.filterInitTimezone();
    this.getProgramActivation();

    // added for cleverTap event capture
    this.store.select('activation').subscribe((activation: any) => {
      if(activation && activation.length) {
        this.activationData = activation[0];
      }
    });
  }


  get f() { return this.resetPasswordForm.controls; }

  getProgramActivation() {
    this.dashboardService.getProgramActivation().subscribe(res => {
      if(res && res['data'] && res['data'].length) {
        this.storeData = res['data'][0];
        this.isleaderboard = res['data'][0]['program']['activation']['enableProgramLeaderboard'];

        // capture event
        try {
          this.activationData = res['data'][0];
          if(this.user && this.activationData) {
            let eventData = { user: this.user, activationData: this.activationData }
            this.eventsService.viewProfileEvent(eventData);
          }
        } catch (err) {
          console.log(err);
        }
      }
    })
  }

  onClick(event){
    event.preventDefault();
  }

  getProfileById(uuid: string) {
    let getProfileApi = this.profileService.getProfile(uuid);
    forkJoin([getProfileApi]).subscribe((res) => {
      this.formInitailData(res[0])
    },

      (error) => {
        console.log(error);
      })
  }

  formInitailData(object: any) {
    this.imgFile = object.data.profilePic;
    if (object.data.countryCode) {
      this.countryObj = this.country.find(x => x.dial_code == object.data.countryCode);
      this.defaultCountryCode = `${this.countryObj.dial_code} (${this.countryObj.code})`;
    }
    if (object.data.timeZone) {
      this.timezoneObj = this.timezoneDrop.find(x => x.value == object.data.timeZone);
      this.defaultTimezone = ` ${this.timezoneObj.label}`;
    }
    // this.profileForm.patchValue({

    //   firstName: object.data.firstName,
    //   lastName: object.data.lastName,
    //   phone: object.data.phone,
    //   email: object.data.email,
    // })

    // to capture clevertap event
    if(object && object.data) {
      this.userPrevObj.firstName = object.data.firstName;
      this.userPrevObj.lastName = object.data.lastName;
      this.userPrevObj.phone = object.data.phone;
      this.userPrevObj.timeZone = object.data.timeZone
    }

    this.profileForm.patchValue(object.data);
  }
  hideAndShowResetPassword(status: string) {
    if (status === "reset") {
      this.reset_password_enabled = !this.reset_password_enabled;
    } else {
      this.reset_password_enabled = !this.reset_password_enabled;
      this.submitted = false;
      this.resetPasswordForm.reset();
    }


  }


  onSubmit() {
    if(this.profileForm.invalid) {
      this.toaster.error("Please enter valid profile details");
      this.profileForm.markAllAsTouched();
      return;

  }else{
    let createAndUpdateApi = this.profileService.updateUser(this.getProfileFormData(this.profileForm));
    forkJoin([createAndUpdateApi]).subscribe((res) => {
      if (res[0]["msg"] == "Success") {
        this.profileService.setUserData()
        this.toaster.success("Profile Updated Successfully.");
        // caputre event
        this.isProfileUpdated = true;
      }
    }, (error) => {
      this.toaster.error("Something went wrong");
    })
  }
  }
  getProfileFormData(form: any) {
    let object = {
      "profilePic": "",
      "firstName": form.value.firstName,
      "lastName": form.value.lastName,
      "phone": form.value.phone,
      "receiveUpdatesOnWhatsapp": form.value.receiveUpdatesOnWhatsapp,
      "countryCode": form.value.countryCode,
      "timeZone" : form.value.timeZone
    }
    return object;
  }

  resetPassword() {
    this.submitted = true;
    if (this.resetPasswordForm.invalid) {
      return;
    }
    let password = {
      "newPassword": this.encryptionService.encryptData(this.resetPasswordForm.value.newPassword),
      "oldPassword": this.encryptionService.encryptData(this.resetPasswordForm.value.oldPassword)
    }
    let passwordReset = this.profileService.resetPswd(password);
    forkJoin([passwordReset]).subscribe((res) => {
      if (res[0]["msg"] == "Success") {
        this.toaster.success("Password Updated Successfully.");
        this.resetPasswordForm.reset();
        this.isProfileDisable = true;
        this.reset_password_enabled = false;
        this.logout();
      }
    }, (error) => {
      this.toaster.error("Something went wrong");
    })

  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  get lastLearnedDays() {
    return Math.floor((Date.now() - Date.parse(this.lastLoginDate)) / 86400000);
  }

  testNewUpload(event){

    console.log(event)
    if(event.target.files[0].size>2097152){
      this.toaster.error("Profile picture size cannot exceed 2 MB")

    }else if(event.target.files[0].size<30000){
      this.toaster.error("Profile picture size cannot be less than 30 Kb")
    }else{
      this.imageUploadEvent= event;
      this.imageUpload=true;

    }

  }
croppedImage: any='';
  imageCropped(event){
this.croppedImage = event.base64;
  }

  clearEvent(event){
    event.srcElement.value = null;
  }

  UploadFinal(event){
    console.log(event)
    this.profileService.updateProfile({
      profilePic: this.croppedImage,
      firstName: this.profileForm.value.firstName
    },
    ).subscribe(res => {
      if (res) {
        this.profileForm.patchValue({
          imgSrc: this.croppedImage
        });
        this.imgFile= this.croppedImage
        this.profileService.setUserData()
        this.isProfilePic = true;
        this.imageUpload=false;
        this.toaster.success("Profile picture uploaded successfully.");
        event.srcElement.value = null;
      }
    });
  }

  hidePopup() {
    this.imageUpload = false;
  }

  changeListener(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imgFile = reader.result as string;
        this.isChangeRequired = false;
        this.profileService.updateProfile({
          profilePic: this.imgFile,
          firstName: this.profileForm.value.firstName
        },
        ).subscribe(res => {
          if (res) {
            this.profileForm.patchValue({
              imgSrc: reader.result
            });
            this.profileService.setUserData()
            this.isProfilePic = true;
            this.toaster.success("Profile picture uploaded successfully.");
            event.srcElement.value = null;
          }
        });
      };
    }
  }


  deleteProfilePic(event) {

    this.profileService.updateProfile({ profilePic: null, firstName: this.profileForm.value.firstName }).subscribe(res => {
      console.log(res, "Delete")
      this.imgFile = "";
      if (res) {
        // this.profileForm.patchValue({
        //   imgSrc: null
        // });
        this.profileService.setUserData()
        this.toaster.warning("Profile picture deleted successfully.");
      }
    });
  }

  mustMatchPassword() {
    let oldPass =  this.resetPasswordForm.value.oldPassword;
    let npassword = this.resetPasswordForm.value.newPassword
    let cpassword = this.resetPasswordForm.value.confirmPassword
    let isMatch = npassword === cpassword ? false : true;
    if( oldPass === npassword){
      this.resetPasswordForm.controls['newPassword'].setErrors({'same': true});
    }
    if(!isMatch && ((npassword != null) && (npassword != ''))) {
      this.submitted = true;
    } else {
      this.submitted = false;
    }
    // console.log("test", isMatch);
    return isMatch
  }

  countrySelected(country) {
    this.showDropDown = false;
    if(country) {
      this.defaultCountryCode = `${country.dial_code} (${country.code})`;
      this.countryObj = country;
      this.profileForm.get('countryCode').patchValue(country.dial_code);
    }
  }

  timezoneSelected(timezone) {
    this.showDropDown = false;
    if(timezone) {
      this.defaultTimezone = `${timezone.label}`;
      this.timezoneObj = timezone;
      this.profileForm.get('timeZone').patchValue(timezone.value);
    }
  }

  filterInit() {
    this.showDropDown = false;
  }

  showDropdown() {
    this.showDropDown = !this.showDropDown;
  }

  showTimezone() {
    this.showTimeZone = !this.showTimeZone;
  }
  filterInitTimezone() {
    this.showTimeZone = false;
  }

  filterFunction(event) {
    let getDiv = document.getElementById("myDropdown");

    var filter, a, i;
    filter = event.target.value.toUpperCase();
    a = getDiv.getElementsByTagName("li");
    for (i = 0; i < a.length; i++) {
      let txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";

      } else {
        a[i].style.display = "none";
      }
    }
  }

  filterTimezone(event) {
    let getDiv = document.getElementById("myDropdownTimezone");

    var filter, a, i;
    filter = event.target.value.toUpperCase();
    a = getDiv.getElementsByTagName("li");
    for (i = 0; i < a.length; i++) {
      let txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";

      } else {
        a[i].style.display = "none";
      }
    }
  }
  removePhoneSearch(e) {
    var getBtn = document.querySelector(".dropbtn");
    var getInput = document.getElementById("myInput");
    var getBtnTimezone = document.querySelector(".dropbtnTimezone");
    var getInputTimezone = document.getElementById("myInputTimezone");
    if (e.target !== getBtn && e.target !== getInput) {
      this.showDropDown = false;
    }
    if (e.target !== getBtnTimezone && e.target !== getInputTimezone) {
      this.showTimeZone = false;
    }
  }

  logout() {
    this.authService.logout(this.user, this.activationData);
  }
}
